import React from "react";
import "./AboutUs.css";
import aboutUsBanner from "../assets/images/AboutUsBanner.png";
import aboutUsImg from "../assets/images/AboutUs.png";

function AboutUs() {
  return (
    <div className="aboutus-bg">
      {/* Banner */}
      <div className="aboutus-banner">
        <img src={aboutUsBanner} alt="About Vicon" className="aboutus-banner-img" />
      </div>

      {/* Two-column content */}
      <div className="aboutus-content">
        <div className="aboutus-image-col">
          <img src={aboutUsImg} alt="Vicon Products" className="aboutus-img" />
        </div>
        <div className="aboutus-text-col">
          <h1>About Us</h1>
          <p>
            VICON Products &amp; Services is a trusted name in high-quality spare
            parts and accessories for home appliances. We offer a reliable range
            of products for refrigerators, air conditioners, washing machines,
            microwaves, and more, designed to support better performance, safety,
            and longer appliance life.
          </p>
          <p>
            Our products are built for compatibility, durability, and easy
            replacement across leading appliance brands. With a focus on quality
            and customer satisfaction, VICON supports dealers, distributors,
            retailers, and service professionals with dependable spare part
            solutions.
          </p>
        </div>
      </div>
    </div>
  );
}

export default AboutUs;
